import { useGetMutualFundInvestmentLimitsQuery } from '@fintronners/react-api/src';
import { QuantityType, TradeSide } from '../constants';
import { getMinimumTradeAmount, getMutualFundMinimumTradeAmount } from '../utils';
import { useMemo } from 'react';
import FinTronConfig from '@fintronners/react-config/src/Config/FinTronConfig';

const useTradeMinAmountLimit = (
  side?: TradeSide,
  assetId?: string,
  quantityType?: QuantityType,
) => {
  const trades = FinTronConfig.selfDirected.trades;

  const { data } = useGetMutualFundInvestmentLimitsQuery({
    variables: { securityID: assetId ?? '' },
    skip: !assetId || !side,
  });

  const activeBalance = data?.userAccountPortfolioAssets?.edges?.[0]?.node?.balances?.activeBalance;
  const ownSecurity = activeBalance && activeBalance > 0;
  const mfDetails = data?.securityAssets.edges?.find((edge) => edge?.node?.id === assetId)?.node
    ?.details;

  const minimumAmount = useMemo(() => {
    if (!side) return trades.buyMin;

    if (mfDetails?.__typename === 'SecurityMutualFundDetails') {
      return getMutualFundMinimumTradeAmount(
        side,
        ownSecurity,
        mfDetails.initialInvestmentMinimum,
        mfDetails.additionalInvestmentMinimum,
      );
    }

    return getMinimumTradeAmount(side, quantityType);
  }, [side, ownSecurity, mfDetails, quantityType]);

  return minimumAmount;
};

export default useTradeMinAmountLimit;
